import { Link } from 'react-router-dom';
import { mainSiteUrl, articlePages, categoryLinks } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-file-excel-2-line text-2xl text-primary-400"></i>
              </div>
              <span className="font-heading text-lg text-background-50">BaseTao Sheet</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              An independent educational resource for BaseTao Spreadsheet research.
              We help shoppers organize, track, and optimize their BaseTao experience
              with practical guides and tools.
            </p>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 mt-4 px-5 py-2.5 bg-accent-500 text-background-50 rounded-lg text-sm font-semibold hover:bg-accent-400 transition-colors duration-200 whitespace-nowrap"
            >
              Visit BaseTao Spreadsheet
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </div>
            </a>
          </div>

          <div>
            <h4 className="font-heading text-sm text-background-50 mb-4">Core Guides</h4>
            <ul className="space-y-2.5">
              <li><Link to="/shopping-guide/" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-150">Shopping Guide</Link></li>
              <li><Link to="/basetao-spreadsheet/" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-150">BaseTao Spreadsheet</Link></li>
              <li><Link to="/basetao-review/" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-150">BaseTao Review</Link></li>
              <li><Link to="/basetao-shipping-cost/" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-150">Shipping Cost Guide</Link></li>
              <li><Link to="/is-basetao-legit/" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-150">Is BaseTao Legit?</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm text-background-50 mb-4">Tools & Resources</h4>
            <ul className="space-y-2.5">
              <li><Link to="/basetao-spreadsheet-template/" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-150">Spreadsheet Templates</Link></li>
              <li><Link to="/basetao-spreadsheet-tutorial/" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-150">Step-by-Step Tutorial</Link></li>
              <li><Link to="/basetao-cost-tracker/" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-150">Cost Tracker</Link></li>
              <li><Link to="/basetao-shipping-calculator/" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-150">Shipping Calculator</Link></li>
              <li><Link to="/basetao-qc-process/" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-150">QC Process Guide</Link></li>
              <li><Link to="/basetao-spreadsheet-download/" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-150">Download Spreadsheet</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm text-background-50 mb-4">More</h4>
            <ul className="space-y-2.5">
              <li><Link to="/basetao-promo-code/" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-150">Promo Code Guide</Link></li>
              <li><Link to="/basetao-shipping-usa/" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-150">Shipping to USA</Link></li>
              <li><Link to="/basetao-vs-superbuy/" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-150">BaseTao vs Superbuy</Link></li>
              <li><Link to="/basetao-alternatives/" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-150">All Alternatives</Link></li>
              <li><Link to="/about/" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-150">About Us</Link></li>
              <li><Link to="/contact/" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-150">Contact</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800/50 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} BaseTao Sheet. An independent resource &mdash; not affiliated with BaseTao.
          </p>
          <div className="flex items-center gap-4">
            <Link to="/privacy-policy/" className="text-xs text-background-500 hover:text-background-300 transition-colors">
              Privacy Policy
            </Link>
            <Link to="/contact/" className="text-xs text-background-500 hover:text-background-300 transition-colors">
              Contact
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}